import getThemeClasses from "@oxygen/theme";
import { platform as PLATFORM } from "GlobalEnum/Platform";
import { CustomLink } from "GlobalUtils/CustomLink";
import { Track } from "GlobalUtils/Track";
import {
  getModelPageUrl,
  getNewCarOfferListingPageUrl,
} from "GlobalUtils/UrlFactory";
import React, { memo } from "react";
import { NEW_CARS_ENDPOINT } from "SrcPath/NewCars/constants/Global";
import styles from "./scss/NewCarSearchSuggestions.module.scss";

const CAR_DISCOUNT_URL = getNewCarOfferListingPageUrl();
const placeholderClasses = getThemeClasses(`
  display-flex;
  justify-content-space-between;
`);
function getHelperTextClasses(searchExample, isMobile) {
  return getThemeClasses(`
    font-size-6.5;
    mt-4;
    color-white;
    ${!isMobile && searchExample ? placeholderClasses : "text-align-center"}
  `);
}
const helperLinkClasses = getThemeClasses(`
  color-white;
`);

export const NewCarSearchSuggestions = memo(function NewCarSearchSuggestions({
  searchExample,
  platform,
}) {
  const isMobile = platform.id === PLATFORM.MOBILE.id;
  const { makeName, makeMaskingName, modelName, modelMaskingName } =
    searchExample || {};
  return (
    <div className={getHelperTextClasses(searchExample, isMobile)}>
      {!isMobile && makeName && modelName && (
        <p>
          {"e.g. "}
          <Track
            as={CustomLink}
            to={getModelPageUrl(makeMaskingName, modelMaskingName)}
            title={`${makeName} ${modelName}`}
            className={`${helperLinkClasses} ${styles.searchSuggestions}`}
            trackClick
            gaCat={`FirstPanel-${platform.trackingName}-HP`}
            gaActClick={`${makeName}-${modelName}-Click`}
          >
            {`${makeName} ${modelName}`}
          </Track>
        </p>
      )}
      <p>
        <Track
          as={CustomLink}
          to={CAR_DISCOUNT_URL}
          title="View New Car Discounts"
          className={`${helperLinkClasses} ${styles.searchSuggestions}`}
        >
          {"New Car Discounts"}
        </Track>
        <span>{" | "}</span>
        <Track
          as="a"
          href={isMobile ? "/find-car/" : NEW_CARS_ENDPOINT}
          title="Help me find a car"
          className={`${helperLinkClasses} ${styles.searchSuggestions}`}
          trackClick
          gaCat={isMobile ? "NCFLinkage" : "HomePage"}
          gaActClick={isMobile ? "NCFLinkage_click" : "Linkage_click"}
          gaLblClick="Help me find a car"
        >
          {"Help Me Find A Car"}
        </Track>
      </p>
    </div>
  );
});

NewCarSearchSuggestions.displayName = "NewCarSearchSuggestions";
